var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("entries",c,p,1),c,p,0,12,40,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<movie-new-react-partial0",c,p,""));});c.pop();}return t.fl(); },partials: {"<movie-new-react-partial0":{name:"movie-new-react-partial", partials: {}, subs: {  }}}, subs: {  }}, "{{#entries}}{{>movie-new-react-partial}}{{/entries}}", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/haku-movie-partial.mustache
// module id = 752
// module chunks = 2